import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'BasketFreeShipping',
  setup(__props) {

function isWhiteSpace(str: string): boolean {
    return str.trim().length === 0;
}

return { __sfc: true,isWhiteSpace }
}

})